<div class="widget-header">
  <dsy-heading class="widget-header__title" level="h4" level-size="xl" level-style="bold">
    {{ title() }}
  </dsy-heading>
  @if (link(); as l) {
    <dr-flex-home-ui-link-button class="widget-header__link" [link]="l" [mixpanelClickEvent]="mixpanelClickEvent()" size="sm" />
  } @else if (customRightWidget()) {
    <ng-content select="[customRightWidget]"></ng-content>
  }
</div>
